import type { RepoUrlParts } from '#utils/codeRefs/types';

/**
 * Creates a repo url based on a commit or a hunk template.
 * @param urlTemplate Can be one of:
 *  - commitUrlTemplate "https://github.com/launchdarkly/SupportService/tree/${sha}",
 *  - hunkUrlTemplate "https://github.com/launchdarkly/SupportService/support-service/blob/${sha}/${filePath}#L${lineNumber}",
 * @param urlParts
 */
export const createRepoUrl = (urlTemplate: string, urlParts: RepoUrlParts) => {
  let result = urlTemplate;

  Object.keys(urlParts).forEach((k) => {
    result = result.replace(`$\{${k}}`, `${urlParts[k]}`);
  });

  return result;
};
